// import React, { useEffect, useState } from 'react'
import { BrowserRouter, MemoryRouter, Route, Routes } from 'react-router-dom';

import AppointmentPage from '../Component/BookingJourney/AppointmentPage';

import ReschedulePage from '../Component/BookingJourney/reschedule';
import ReschedulePageV2 from '../Component/BookingJourney/rescheduleV2';
import RescheduleTrigger from './RescheduleTriggle';
import GoogleCalander from '../Component/BookingJourney/GoogleCalander';
import GoogleCalanderV2 from '../Component/BookingJourney/GoogleCalanderV2';
import BookingConfirmation from '../Component/Dashboard/BookingConfirmation';

const hardcodedProps = {
    "getAllHealthScreenData": {
        "tempData": {
            "product": "General GP consultation",
            "data": [
                {
                    "key": "Duration",
                    "data": "15 minutes"
                },
                {
                    "key": "languageData",
                    "data": "Arabic"
                },
                {
                    "key": "Gender",
                    "data": "Male"
                }
            ],
            "date": "14 January, 2025",
            "time": "10:30",
            "name": "Oxford Street",
            "address": "6 Newburgh Street, Carnaby, London, W1F 7RQ"
        }
    },
    "showAppoinmentData": {
        "duration": 1,
        "language": "English",
        "gender": "no_preference",
        "price": "£  40.00",
        "type": "BookingForm",
        "slot": {
            "date": "Fri, 25 Jul2025",
            "info": {
                "start_time": "16:15"
            },
            "clinicData": {
                "id": 47,
                "name": "Hampstead (London Doctors Clinic)",
                "address": "213 Haverstock Hill, Belsize Park, London, NW3 4QP",
                "latitude": "-.1692526",
                "longitude": "51.5509691"
            }
        },
        "clinic": {
            "productCategory": {
                "title": "GP appointment",
                "product_category_id": 1
            },
            "non_gp_product_id": null
        }
    },
    "data": {

    },
    "BookedAppointmentPayload": {
        "success": true,
        "message": "Appointment booked successfully.",
        "data": {
            "patient_id": 271,
            "room_id": "247",
            "duration_id": 1,
            "product_id": null,
            "preferred_gender": "no_preference",
            "appointment_type_int": 1,
            "charges": "40.00",
            "start_time": "2025-07-25 16:15",
            "end_time": "2025-07-25 16:30",
            "booked_on": "2025-07-25T14:20:03.045316Z",
            "notes": "sdf",
            "clinic_id": 47,
            "product_category_id": 1,
            "cancellations_rescheduling_allowed": 1,
            "appointment_reason_id": 0,
            "status": 1,
            "appt_source": 1,
            "created_by": null,
            "updated_by": null,
            "parent_id": "AP-0000000230",
            "updated_at": "2025-07-25T14:20:03.046000Z",
            "created_at": "2025-07-25T14:20:03.046000Z",
            "appointment_id": 315,
            "latitude": "-.1692526",
            "longitude": "51.5509691"
        },
        // "google_calendar": {
        //     "requires_auth": true,

        //     "auth_url": "https://accounts.google.com//o//oauth2//v2//auth?response_type=code&access_type=offline&client_id=360487503727-ib23qh79b7d2br63bqlfu8ptqp7qgtsn.apps.googleusercontent.com&redirect_uri=https%3A%2F%2Fpbldcbe.webdezign.uk%2Fgoogle-calendar%2Fcallback&state=315&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fcalendar&prompt=consent"
        // }
        "google_calendar": {
        "requires_auth": false
    }
    }
}

const MainRouter = (props) => {

            const isWidgetMode = process.env.REACT_APP_WIDGET_MODE === 'true';
            const initialPath = props.initialPath || "/";
            // console.log("MainRouter product_category_id:", props); 
            const encrypted  = props.resheduleKey || "";
            const stateCode  = props.stateCode || "";
            const authCode  = props.authCode || "";
            return (
                <>
                    {isWidgetMode ? (
                        <MemoryRouter initialEntries={[initialPath]}>
                            <Routes>
                                <Route path="/" element={<AppointmentPage productCategoryId={props.productCategoryId}/>} productId={props?.productId} clinicId={props?.clinicId}/>
                                <Route path="/booking_confirmation" element={<BookingConfirmation {...hardcodedProps} />} />
                                {/* <Route path="/book" element={<UnifiedAppointmentType />} />
                                <Route path="/gp-journey" element={<AppointmentPage />} />
                                <Route path="/gp-book-journey" element={<BookingJourney />} />
                                <Route path="/health-booking" element={<Hbooking />} />
                                <Route path="/health-journey" element={<HJourney />} /> */}
                                <Route path={`/view-appointment`} element={<ReschedulePageV2 encryptedId={encrypted} />} />
                                <Route path="/google-calendar" element={<GoogleCalanderV2 stateCode={stateCode} authCode={authCode}/>} />
                                <Route path="/view-appointment-trigger" element={<RescheduleTrigger /> } />
                            </Routes>
                        </MemoryRouter>
                    ) : (
                        <BrowserRouter>
                            <Routes>
                                <Route path="/" element={<AppointmentPage product_category_id={2}/>} />
                                <Route path="/booking_confirmation" element={<BookingConfirmation {...hardcodedProps} />} />
                                {/* <Route path="/book" element={<UnifiedAppointmentType />} />
                                <Route path="/gp-journey" element={<AppointmentPage />} />
                                <Route path="/gp-book-journey" element={<BookingJourney />} />
                                <Route path="/health-booking" element={<Hbooking />} />
                                <Route path="/health-journey" element={<HJourney />} /> */}
                                <Route path="/view-appointment/:encryptedId" element={<ReschedulePage />} />
                                <Route path="/google-calendar/:code" element={<GoogleCalander />} />
                                <Route path="/view-appointment-trigger" element={<RescheduleTrigger /> } />
                            </Routes>
                        </BrowserRouter>
                    )}
                </>
            );
};

export default MainRouter
